import { ca } from '@cian/analytics';

import { IOffer } from '../../../../types/offer';

interface ITrackWriteClickParams {
  offer: IOffer;
  position: number;
  isEarlyAccess?: boolean;
  source?: string;
  mlSearchSessionGuid: string | null;
}

interface ITrackWriteClickBlockedParams {
  offer: IOffer;
  position: number;
  blockType: string;
  source?: string;
  mlSearchSessionGuid: string | null;
}

export function trackWriteClick({
  offer,
  position,
  isEarlyAccess = false,
  source,
  mlSearchSessionGuid,
}: ITrackWriteClickParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'send_message',
    label: offer.gaLabel,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        mlSearchSessionGuid,
        /* istanbul ignore next */
        opponent_id: offer.user?.cianUserId,
        type: 'Open_listing_agent_block',
        is_early_access: isEarlyAccess,
        source,
      },
    },
  });
}

export function trackWriteClickBlocked({
  offer,
  position,
  blockType,
  source,
  mlSearchSessionGuid,
}: ITrackWriteClickBlockedParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'send_message_blocked_early_access',
    label: offer.gaLabel,
    products: [
      {
        id: offer.id,
        offerType: 'offer',
        position,
      },
    ],
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
      extra: {
        mlSearchSessionGuid,
        opponent_id: offer.user?.cianUserId,
        type: 'Open_listing_agent_block',
        block_type: blockType,
        source,
      },
    },
  });
}
